import Navbar from '../components/ArtisttoHeader';
import ArtisttoFooter from '../components/ArtisttoFooter';
import HeroSection from '../components/About/HeroSection';
import EcosystemSection from '../components/About/EcosystemSection';
import OriginStorySection from '../components/About/OriginStorySection';
import MissionFutureSection from '../components/About/MissionFutureSection';
import ImpactSection from '../components/About/ImpactSection';
import LeadershipSection from '../components/About/LeadershipSection';
import CtaSection from '../components/About/CtaSection';

const About = () => {
  return (
    <>
      <Navbar />
      <div className="font-inter bg-black overflow-x-hidden">
        <HeroSection />
        <EcosystemSection />
        <OriginStorySection />
        <MissionFutureSection />
        <ImpactSection />
        <LeadershipSection />
        <CtaSection />
      </div>
      <ArtisttoFooter />
    </>
  );
};

export default About;
